export default __webpack_public_path__ + "static/media/Landing_page_Desktop.0192977e.png";